import { Component, inject, signal } from '@angular/core'
import { rxResource } from '@angular/core/rxjs-interop'
import { OrdersService } from 'src/app/core/services/orders/orders.service'
import { CardComponent } from 'src/app/shared/components/card/card.component'
import { CalendarRangeSelectorComponent } from 'src/app/shared/components/form-elements/calendar-range-selector/calendar-range-selector.component'
import { OrdersTableComponent } from 'src/app/shared/components/orders/orders-table/orders-table.component'
import { PageTitleComponent } from 'src/app/shared/components/page-title/page-title.component'
import { PaginationDetailComponent } from 'src/app/shared/components/pagination-detail/pagination-detail.component'
import { OrderFilter } from 'src/app/shared/interfaces/orders/orders-filter.interface'
import { Utils } from 'src/app/shared/utilties'

@Component({
    selector: 'sf-orders',
    imports: [
        CardComponent,
        PaginationDetailComponent,
        PageTitleComponent,
        OrdersTableComponent,
        CalendarRangeSelectorComponent,
    ],
    templateUrl: './orders.component.html',
    styleUrl: './orders.component.scss',
})
export class OrdersComponent {
    #ordersService = inject(OrdersService)

    today = new Date()

    #filter = signal<OrderFilter>({
        from: Utils.getDateFirstOfTheMonth(),
        to: this.today.toISOString(),
        pageNumber: 1,
        pageSize: 20,
    })

    filter = this.#filter.asReadonly()

    #orders = rxResource({
        params: () => this.#filter(),
        stream: ({ params }) => this.#ordersService.getOrdersPaged(params),
    })

    orders = this.#orders.asReadonly()

    onPageChanged(pageNumber: number): void {
        this.#filter.update((current) => ({ ...current, pageNumber }))
    }

    onDateChanged(range: { from: string | null; to: string | null }): void {
        this.#filter.update((current) => ({ ...current, ...range }))
    }
}
